import { LegacyPortalShippingStatusDispatchStatus } from "@spwn-portal/grpc";
import { SHIPMENT_STATUS } from "ui/StatusLabel/constants/shipmentStatus";
import { STATUS } from "ui/StatusLabel/constants/status";

import type { Status } from "ui/StatusLabel/types/status";

type GetShippingLabelStatus = (
  dispatchStatuses: LegacyPortalShippingStatusDispatchStatus[]
) => Status;

export const getShippingLabelStatus: GetShippingLabelStatus = (
  dispatchStatuses
) => {
  if (
    dispatchStatuses.includes(LegacyPortalShippingStatusDispatchStatus.SHIPPED)
  ) {
    return SHIPMENT_STATUS.SHIPPED;
  }

  if (
    dispatchStatuses.includes(LegacyPortalShippingStatusDispatchStatus.PACKING)
  ) {
    return SHIPMENT_STATUS.PREPARING_SHIPMENT;
  }

  // その他（UNSPECIFIED等）は非表示
  return STATUS.NO_LABEL;
};
